













import { OComponentDemo } from '../../app/demo';
import OCheckbox from './o-checkbox.vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'OCheckboxDemo',
  data() {
    return {
      data: {
        apple: true,
        banana: false,
        cucumber: false,
        fruits: [{ value: 'BANANA' }],
      },
    };
  },
  components: { OCheckbox, OComponentDemo },
});
